import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { get as _get } from "lodash";

//import IconLinkSecondary from "../../../assets/icons/icon-link-secondary.svg";
import IconRelatedNews from "../../../assets/icons/icon-related-news.svg";
import IconLinkedIn from "../../../assets/icons/icon-linkedin.svg";
import IconWarning from "../../../assets/icons/icon-warning.svg";
import IconEMail from "../../../assets/icons/icon-email.svg";

class KeyContacts extends Component {

  render() {
    const { companyCardDetail } = this.props;

    return (
      <div className="tab-pane fade show active">
        <div className="row gy-4 mt-0">
          <div className="col-lg-12">
            <h3 className="heading-04 fw-bold text-dark mb-1">
              <FormattedMessage id="company_card.contacts.title" defaultMessage="Key Decision Makers" />
            </h3>
            <p className="text-grey-93 mb-0">
              <FormattedMessage id="company_card.contacts.subtitle" defaultMessage="Direct contact mapping for the Europe and Global hubs." />
            </p>
          </div>
        </div>

        <div className="d-flex flex-column gap-4 mt-4">
          {(_get(companyCardDetail, "key_contacts") || []).length > 0 ? (
            (_get(companyCardDetail, "key_contacts") || []).map((contact, idx) => {
              const contactEngagements = _get(contact, "recent_engagements") || [];

              return (
                <div key={idx} className="card rounded-4 border border-grey-e6 shadow-none w-100">
                  <div className="card-body">
                    <div className="row gx-lg-8">

                      {/* Contact details */}
                      <div className="col-lg-4">
                        <p className="fw-bold text-dark heading-02 text-capitalize">{_get(contact, "triggered_by", "")}</p>
                        <p className="text-grey-93 mb-4 heading-05 text-capitalize">{_get(contact, "job_title", "")}</p>

                        <div className="d-flex align-items-center gap-2 p-3 bg-grey-fa rounded-3 border mb-4">
                          <img src={IconEMail} alt="Email" />
                          <span className="fw-bold text-black">{_get(contact, "email", "")}</span>
                        </div>

                        <button
                          className="btn btn-secondary text-capitalize waves-effect"
                          onClick={() => {
                            const url = _get(contact, "linkedin_url", "");
                            if (url) window.open(url, "_blank");
                          }}
                        >
                          <img src={IconLinkedIn} alt="LinkedIn" />
                          <FormattedMessage id="company_card.contacts.view_profile" defaultMessage="View Profile" />
                        </button>
                        {(_get(contact, "personality_card_url", "") !== "") && (
                          <button
                            className="btn btn-primary mx-3 text-capitalize waves-effect"
                            onClick={() => {
                              const url = _get(contact, "personality_card_url", "");
                              if (url) window.open(url, "_blank");
                            }}
                          >
                            <FormattedMessage id="company_card.contacts.personality_card" defaultMessage="Personality Card" />
                          </button>
                        )}
                      </div>

                      {/* Engagement history for this contact */}
                      <div className="col-lg-8 border-start">
                        <p className="text-uppercase fw-bold mb-3 d-flex gap-1 align-items-center text-grey-93 heading-06">
                          <img src={IconRelatedNews} alt="Related News Icon" />
                          <FormattedMessage id="company_card.contacts.recent_engagement" defaultMessage="Recent Engagement" />
                        </p>

                        {contactEngagements.length > 0 ? (
                          <div className="d-flex flex-column gap-2">
                            {contactEngagements.map((event, k) => (
                              <div key={k} className="d-flex justify-content-between d-flex align-items-center gap-2 p-3 bg-grey-fa rounded-3 border">
                                <div className="w-100">
                                  <div className="d-flex align-items-center gap-2 justify-content-between mb-3">
                                    <div className="d-flex align-items-center gap-2">
                                      <span className="badge text-primary border border-primary bg-primary-66 text-uppercase rounded-2 p-2 py-1">{_get(event, "type", "")}</span>
                                      <span className="text-grey-93 fw-semibold heading-06">{_get(event, "date", "")}</span>
                                    </div>
                                  </div>
                                  <p className="fw-bold text-dark heading-05 mb-0 text-capitalize">{_get(event, "asset", "")}</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div key={`nodata-${idx}`} className="d-flex justify-content-center d-flex align-items-center gap-2 p-3 bg-grey-fa rounded-3 border" style={{ minHeight: 120, borderStyle: "dashed" }}>
                            <div className="text-center">
                              <img src={IconWarning} alt="No Engagements" />
                              <p className="text-grey-93 heading-05 fw-semibold mt-2">
                                <FormattedMessage id="company_card.contacts.no_engagement" defaultMessage="No direct engagement recorded." />
                              </p>
                            </div>
                          </div>
                        )}
                      </div>

                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="d-flex justify-content-center align-items-center p-3 bg-grey-fa rounded-3 border" style={{ minHeight: 120, borderStyle: "dashed" }}>
              <div className="text-center">
                <p className="text-grey-93 heading-05 fw-semibold mt-2 mb-0">
                  <FormattedMessage id="label.no_data_found" defaultMessage="No data found." />
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default KeyContacts;
